import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { UserCheckIcon, ShieldCheckIcon, MessageSquareIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
export function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const features = [{
    icon: UserCheckIcon,
    title: 'Personalized Care Plans',
    description: "We don't believe in one-size-fits-all. Every patient receives a tailored care plan designed to meet their unique medical goals and personal preferences."
  }, {
    icon: ShieldCheckIcon,
    title: 'A Commitment to Safety & Comfort',
    description: 'Our care is designed to be a warm, welcoming, and secure in the comfort of your home to promote healing and maintains your dignity.'
  }, {
    icon: MessageSquareIcon,
    title: 'Transparent Communication',
    description: "We believe families are partners in care. We maintain open, honest communication so you are always informed about your loved one's progress."
  }];
  return <section className="py-12 md:py-16 bg-light-alt overflow-hidden" data-id="element-373">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-374">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-375">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-376">
            <div className="inline-flex items-center space-x-2 bg-primary/10 rounded-full px-4 py-2 mb-6" data-id="element-377">
              <StarIcon className="h-4 w-4 text-primary" data-id="element-378" />
              <span className="text-primary font-bold text-sm tracking-wider uppercase" data-id="element-379">
                The Edvin Difference
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6" data-id="element-380">
              Why Choose Edvin Home Health Care Solution and Nursing Services
            </h2>
            <p className="text-lg text-dark-muted" data-id="element-381">
              Selecting a home healthcare provider is a deeply personal and
              important decision. At Edvin Home Health Care Solution and Nursing
              Services, we combine professional medical expertise with genuine
              compassion to deliver unparalleled care.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-382">
            {features.map((feature, idx) => <div key={idx} className="relative bg-light rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group" data-id="element-383">
                <div className="bg-primary/10 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary transition-colors duration-300" data-id="element-384">
                  <feature.icon className="h-8 w-8 text-primary group-hover:text-white transition-colors duration-300" data-id="element-385" />
                </div>
                <h3 className="text-xl font-bold text-dark mb-4" data-id="element-386">
                  {feature.title}
                </h3>
                <p className="text-dark-muted leading-relaxed text-sm lg:text-base" data-id="element-387">
                  {feature.description}
                </p>
                <div className="mt-6 flex items-center text-primary font-bold text-sm" data-id="element-388">
                  <CheckCircleIcon className="h-4 w-4 mr-2" data-id="element-389" />
                  <span data-id="element-390">Quality Guaranteed</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}